"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * FieldSet with a legend label.
 *
 * peut ontenir un <tl-field-tooltip>
 */
ngModule.directive("tlField", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: false,
    template: '<div class="tl-field" ng-transclude></div>',
    controller: function controller($scope, $element) {
      var ctrl = this,
        tooltipCtrl = null;
      ctrl.getInputElements = function () {
        var inlineCheckbox = $element.find("label.has-cb, .tl-checkbox");
        return inlineCheckbox.length ? inlineCheckbox : $element.find("input, select, .tl-select, .tl-input-wrapper");
      };
      ctrl.setTooltipCtrl = function (_tooltipCtrl) {
        tooltipCtrl = _tooltipCtrl;
        tooltipCtrl.bindTooltip();
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/tlField.js
// module id = 2951
// module chunks = 13